import { AppTheme, appThemeByDomain } from '@/features/common/constants';

export const getAppTheme = (): AppTheme => {
  if (!window?.location?.hostname) return AppTheme.Default;

  const domain = window.location.hostname.split('.')[0];

  return appThemeByDomain[domain] || AppTheme.Default;
};
